/* ============================================================
   house of zense — theme JS
   Cart is backed by Shopify's AJAX Cart API (/cart/*.js),
   replacing the prototype's localStorage cart.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- toast ---------- */
  var toast = document.getElementById('toast');
  var toastTx = document.getElementById('toastTx');
  var toastLink = document.getElementById('toastLink');
  var tT;
  function showToast(m, opts) {
    if (!toast) return;
    opts = opts || {};
    if (toastTx) toastTx.textContent = m;
    if (toastLink) toastLink.hidden = !opts.cartLink;
    toast.classList.add('show');
    clearTimeout(tT);
    tT = setTimeout(function () { toast.classList.remove('show'); }, opts.cartLink ? 4000 : 2400);
  }
  window.zenseToast = showToast;

  /* ---------- cart count + bubble ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  window.zenseRefreshCount = refreshCount;

  /* ---------- add to cart (AJAX) ---------- */
  function addToCart(id, qty, opts) {
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) { throw data; }
          return data;
        });
      })
      .then(function (item) {
        refreshCount();
        if (opts.toast !== false) showToast('Added to Bag', { cartLink: true });
        if (opts.redirect) window.location.href = '/cart';
        return item;
      })
      .catch(function (err) {
        showToast((err && err.description) || 'Could not add to bag');
        throw err;
      });
  }
  window.zenseAddToCart = addToCart;

  /* ---------- restock notify (real capture via native contact form, no fake promises) ---------- */
  var notifyOverlay = document.getElementById('notifyOverlay');
  var notifyForm = document.getElementById('notifyForm');
  var notifyEmail = document.getElementById('notifyEmail');
  var notifyProductLabel = document.getElementById('notifyProductLabel');
  var notifyProductName = '';
  function openNotify(name) {
    notifyProductName = name || 'this product';
    if (notifyProductLabel) notifyProductLabel.textContent = notifyProductName;
    if (notifyOverlay) { notifyOverlay.classList.add('open'); notifyOverlay.setAttribute('aria-hidden', 'false'); }
    if (notifyEmail) setTimeout(function () { notifyEmail.focus(); }, 100);
  }
  function closeNotify() {
    if (notifyOverlay) { notifyOverlay.classList.remove('open'); notifyOverlay.setAttribute('aria-hidden', 'true'); }
  }
  window.zenseOpenNotify = openNotify;
  if (notifyOverlay) notifyOverlay.addEventListener('click', function (e) { if (e.target === notifyOverlay) closeNotify(); });
  document.querySelectorAll('[data-notify-close]').forEach(function (b) { b.addEventListener('click', closeNotify); });
  if (notifyForm) notifyForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = notifyEmail.value.trim();
    if (!email) return;
    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[name]', 'Restock request');
    fd.append('contact[email]', email);
    fd.append('contact[body]', 'Please email me when "' + notifyProductName + '" is back in stock.');
    fetch('/contact', { method: 'POST', body: fd })
      .then(function () {
        closeNotify();
        showToast("We'll email you when it's back.");
        notifyEmail.value = '';
      })
      .catch(function () { showToast('Something went wrong — please try again.'); });
  });

  /* Quick-add buttons across grids/cards: <button data-add-id="{variant_id}"> */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-id]');
    if (!b) return;
    e.preventDefault();
    if (b.dataset.sold === 'true' || b.hasAttribute('disabled')) {
      openNotify(b.dataset.name);
      return;
    }
    addToCart(b.dataset.addId, 1);
  });

  /* ---------- card add-to-cart control: "Add · size · price" that becomes a
     −/qty/+ stepper in place, per card, once that variant is in the bag ----------
     Markup (see snippets/product-card.liquid, sections/bestsellers.liquid):
       <div class="cta-wrap" data-cta data-vid="{variant_id}">
         <button data-cta-add>Add · 30ML · price</button>
         <div class="cta-stepper" hidden>
           <span class="cta-stepper-label">30ML</span>
           <button data-cta-minus>−</button><span data-cta-qty>1</span><button data-cta-plus>+</button>
         </div>
       </div>
     On load, reads the real cart once and initializes every card to match —
     so a variant already in the bag shows its real quantity, not "Add".
     Duplicate cards for the same product (e.g. the "In Rotation" carousel,
     which triples its markup for seamless infinite scroll) each track their
     own DOM state independently; they don't live-sync with each other, only
     with the cart on next load — the same trade-off the cart-count bubble
     already makes. */
  (function () {
    var wraps = document.querySelectorAll('[data-cta]');
    if (!wraps.length) return;

    function showAdd(wrap) {
      var addBtn = wrap.querySelector('[data-cta-add]');
      var stepper = wrap.querySelector('.cta-stepper');
      if (addBtn) addBtn.hidden = false;
      if (stepper) stepper.hidden = true;
      delete wrap.dataset.key;
    }
    function showStepper(wrap, qty, key) {
      var addBtn = wrap.querySelector('[data-cta-add]');
      var stepper = wrap.querySelector('.cta-stepper');
      var qtyEl = wrap.querySelector('[data-cta-qty]');
      if (addBtn) addBtn.hidden = true;
      if (stepper) stepper.hidden = false;
      if (qtyEl) qtyEl.textContent = qty;
      // key is null during the optimistic instant-swap, before /cart/add.js has
      // responded — leave it unset until the real key arrives, so a stray +/-
      // tap in that brief window is a safe no-op (guarded below) instead of
      // hitting the cart API with an undefined line.
      if (key) wrap.dataset.key = key;
      wrap.dataset.qty = qty;
    }

    /* Sync every card to the real cart, so a returning visitor sees accurate
       quantities instead of every card defaulting to "Add". Also reverts cards
       that are showing a stepper for something no longer in the cart — needed
       because this runs again on bfcache restore (see pageshow below), where
       the cart may have changed since this exact page was last shown. */
    function syncCardsToCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var byVariant = {};
          (cart.items || []).forEach(function (item) {
            if (!byVariant[item.variant_id]) byVariant[item.variant_id] = item;
          });
          wraps.forEach(function (wrap) {
            var match = byVariant[wrap.dataset.vid];
            if (match) showStepper(wrap, match.quantity, match.key);
            else showAdd(wrap);
          });
        })
        .catch(function () {});
    }
    syncCardsToCart();

    /* Safari/Chrome can restore this exact page from bfcache on browser-back
       instead of re-running scripts — event.persisted is true in that case.
       Without this, a cart change made on another page (add, remove, edit
       quantity) never reaches this page's cart bubble or card steppers: the
       DOM stays frozen at whatever it looked like before the visitor navigated
       away. Re-run both syncs so a bfcache restore reflects the real cart. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { refreshCount(); syncCardsToCart(); }
    });

    /* Belt-and-braces alongside pageshow above: re-sync any time this tab
       becomes the visible one again — covers back-navigation edge cases
       pageshow/persisted doesn't catch consistently across mobile browsers,
       and also app-switch-and-return on mobile. Cheap (one small fetch) and
       idempotent, so firing it more often than strictly necessary is fine. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') { refreshCount(); syncCardsToCart(); }
    });

    function changeLine(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-cta-add]');
      if (addBtn) {
        var wrap = addBtn.closest('[data-cta]');
        if (!wrap || addBtn.disabled) return;
        addBtn.disabled = true;
        // Swap to the stepper immediately rather than waiting on the network —
        // no window where both the button and stepper could ever be visible.
        showStepper(wrap, 1, null);
        addToCart(wrap.dataset.vid, 1, { toast: false })
          .then(function (item) {
            showStepper(wrap, item.quantity, item.key); // reconcile with the real key/qty
          })
          .catch(function () {
            showAdd(wrap); // revert — the add genuinely failed
          })
          .finally(function () { addBtn.disabled = false; });
        return;
      }

      var minus = e.target.closest('[data-cta-minus]');
      var plus = e.target.closest('[data-cta-plus]');
      if (!minus && !plus) return;
      var stepWrap = (minus || plus).closest('[data-cta]');
      if (!stepWrap || !stepWrap.dataset.key) return;
      var current = parseInt(stepWrap.dataset.qty, 10) || 1;
      var next = Math.max(0, current + (plus ? 1 : -1));
      var key = stepWrap.dataset.key;
      var qtyEl = stepWrap.querySelector('[data-cta-qty]');
      if (qtyEl) qtyEl.textContent = next; // optimistic
      stepWrap.dataset.qty = next;
      changeLine(key, next)
        .then(function (cart) {
          refreshCount();
          if (next === 0) { showAdd(stepWrap); return; }
          var line = (cart.items || []).filter(function (i) { return i.key === key; })[0];
          if (line && qtyEl) { qtyEl.textContent = line.quantity; stepWrap.dataset.qty = line.quantity; }
        })
        .catch(function () { showToast('Could not update quantity'); });
    });
  })();

  /* Notify-me trigger for individually sold-out size variants on the PDP */
  document.addEventListener('click', function (e) {
    var n = e.target.closest('[data-notify-variant]');
    if (!n) return;
    e.preventDefault();
    openNotify(n.dataset.notifyVariant);
  });

  /* ---------- mobile drawer ---------- */
  var drawer = document.getElementById('drawer');
  var burger = document.getElementById('burger');
  var drawerX = document.getElementById('drawerX');
  if (burger && drawer) burger.addEventListener('click', function () { drawer.classList.add('open'); });
  if (drawerX && drawer) drawerX.addEventListener('click', function () { drawer.classList.remove('open'); });
  if (drawer) drawer.querySelectorAll('[data-close]').forEach(function (a) {
    a.addEventListener('click', function () { drawer.classList.remove('open'); });
  });

  /* ---------- search overlay (same-page, blurred backdrop) ---------- */
  var sOverlay = document.getElementById('searchOverlay');
  var sOpen = document.getElementById('searchOpen');
  var sClose = document.getElementById('searchClose');
  var sInput = document.getElementById('searchInput');
  var sResults = document.getElementById('searchResults');
  function openSearch() {
    if (!sOverlay) return;
    if (drawer) drawer.classList.remove('open');
    sOverlay.classList.add('open');
    sOverlay.setAttribute('aria-hidden', 'false');
    setTimeout(function () { if (sInput) sInput.focus(); }, 120);
  }
  function closeSearch() {
    if (!sOverlay) return;
    sOverlay.classList.remove('open');
    sOverlay.setAttribute('aria-hidden', 'true');
    if (sInput) sInput.value = '';
    if (sResults) { sResults.innerHTML = ''; sResults.hidden = true; }
  }

  /* ---------- predictive search dropdown ---------- */
  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtSuggestPrice(priceStr) {
    var n = parseFloat(priceStr);
    if (isNaN(n)) return '';
    return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function findInsp(p) {
    if (p.insp) return p.insp;
    if (!zenseSearchCatalog) return '';
    var cleanUrl = (p.url || '').split('?')[0];
    for (var i = 0; i < zenseSearchCatalog.length; i++) {
      if (zenseSearchCatalog[i].url === cleanUrl) return zenseSearchCatalog[i].insp || '';
    }
    return '';
  }
  function renderSuggestResults(products, query) {
    if (!sResults) return;
    if (!products || !products.length) {
      sResults.innerHTML = '<div class="sr-empty">No matches for “' + escHtml(query) + '”</div>';
      sResults.hidden = false;
      return;
    }
    sResults.innerHTML = products.slice(0, 6).map(function (p) {
      var img = p.image ? p.image + '&width=88' : '';
      var insp = findInsp(p);
      return '<a class="sr-item" href="' + p.url + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div class="sr-info"><div class="sr-title">' + escHtml(p.title) + '</div>' +
        (insp ? '<div class="sr-insp">' + escHtml(insp) + '</div>' : '') +
        '<div class="sr-type">' + escHtml(p.type) + '</div></div>' +
        '<div class="sr-price">' + fmtSuggestPrice(p.price) + '</div></a>';
    }).join('');
    sResults.hidden = false;
  }
  var suggestDebounce, suggestAbort;
  if (sInput) sInput.addEventListener('input', function () {
    var q = sInput.value.trim();
    clearTimeout(suggestDebounce);
    if (q.length < 2) {
      if (sResults) { sResults.innerHTML = ''; sResults.hidden = true; }
      return;
    }
    suggestDebounce = setTimeout(function () {
      if (suggestAbort) suggestAbort.abort();
      suggestAbort = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { signal: suggestAbort.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          var excludeUrls = {};
          products.forEach(function (p) { excludeUrls[p.url] = true; });
          var related = window.zenseScoreCatalog ? window.zenseScoreCatalog(q, excludeUrls) : [];
          renderSuggestResults(products.concat(related).slice(0, 6), q);
        })
        .catch(function () {});
    }, 220);
  });
  if (sOpen) sOpen.addEventListener('click', openSearch);
  if (sClose) sClose.addEventListener('click', closeSearch);
  if (sOverlay) sOverlay.addEventListener('click', function (e) {
    if (e.target === sOverlay) closeSearch();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
    // press "/" to open search (when not typing in a field)
    if (e.key === '/' && !/input|textarea|select/i.test((e.target.tagName || ''))) {
      e.preventDefault(); openSearch();
    }
  });

  /* ---------- generic accordion (.acc / .notes) ---------- */
  function wireAccordion(root, rowSel, headSel, bodySel) {
    if (!root) return;
    function setBody(row) {
      var b = row.querySelector(bodySel);
      if (!b) return;
      b.style.maxHeight = row.classList.contains('open') ? b.firstElementChild.scrollHeight + 'px' : '0';
    }
    root.querySelectorAll(rowSel).forEach(setBody);
    root.addEventListener('click', function (e) {
      var h = e.target.closest(headSel);
      if (!h) return;
      var row = h.parentElement;
      root.querySelectorAll(rowSel).forEach(function (r) {
        if (r !== row) { r.classList.remove('open'); setBody(r); }
      });
      row.classList.toggle('open'); setBody(row);
    });
    window.addEventListener('resize', function () { root.querySelectorAll(rowSel).forEach(setBody); });
  }
  document.querySelectorAll('[data-accordion="notes"]').forEach(function (el) {
    wireAccordion(el, '.nrow', '.nhead', '.nbody');
  });
  document.querySelectorAll('[data-accordion="details"]').forEach(function (el) {
    wireAccordion(el, '.arow', '.ahead', '.abody');
  });

  /* ---------- home: collection tabs ---------- */
  var tabsRoot = document.getElementById('tabs');
  if (tabsRoot) {
    tabsRoot.addEventListener('click', function (e) {
      var t = e.target.closest('.tab');
      if (!t) return;
      tabsRoot.querySelectorAll('.tab').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var key = t.dataset.k;
      document.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.style.display = p.dataset.tabPanel === key ? '' : 'none';
      });
    });
  }
  document.querySelectorAll('.ct-showmore').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var more = btn.previousElementSibling;
      if (more && more.classList.contains('ct-more')) more.hidden = false;
      btn.remove();
    });
  });

  /* ---------- product rails ("In Rotation" + quick-rail): true infinite loop ----------
     Third build of this thing, and the history is the design rationale:

       v1 rendered the set 3x and teleported vp.scrollLeft on every scroll event to fake an
          endless band. Two faults. Writing scrollLeft mid-fling fights the compositor's own
          momentum, which is what the judder was. And it sized one "set" as scrollWidth/3,
          which quietly swallows the flex gaps and ignores the viewport's inline padding —
          so its wrap band and the real scroll range disagreed and it parked on bare track.

       v2 gave up on infinite and used a plain finite native-scroll rail. Correct, but a
          finite rail has ends, and ends can be rubber-banded past: overscroll-behavior-x
          contain blocks scroll *chaining* while still permitting the elastic pull. That
          pull is the black gap after the last card on Android.

     v3 (this) does not use native scroll at all. Position is a plain JS number applied as
     a transform, reduced modulo one set width on every frame — so the rail is in a bit-for-
     bit identical state after 100 loops as after one. No accumulation, no drift, no end to
     pull against, and scrollLeft is never touched, so there is nothing to fight. Falls back
     to the CSS-only native rail if this never runs. */
  document.querySelectorAll('[data-rot]').forEach(function (rot) {
    var vp = rot.querySelector('[data-rot-viewport]');
    var track = rot.querySelector('.rot-track');
    var setCount = parseInt(rot.getAttribute('data-rot-count'), 10);
    if (!vp || !track || !setCount) return;
    // Looping needs a second set to wrap into; without one, leave the native rail alone.
    if (track.children.length < setCount * 2) return;

    var GAP = 18;                                     // matches .rot-track's gap
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pos = 0, setW = 0, anim = null;

    // Duplicate sets are decorative: keep them out of the a11y tree and the tab order.
    function markClones() {
      for (var i = setCount; i < track.children.length; i++) {
        var el = track.children[i];
        el.setAttribute('aria-hidden', 'true');
        el.querySelectorAll('a,button,input,select,textarea').forEach(function (n) { n.tabIndex = -1; });
      }
    }

    function itemW() { return track.children[0].getBoundingClientRect().width + GAP; }

    function measure() {
      // Exact width of one set: the gap between an item and its twin one set along.
      // getBoundingClientRect (not offsetLeft) because offsetLeft rounds to whole pixels,
      // and a fractional card width would leave a sub-pixel seam at every wrap.
      var a = track.children[0].getBoundingClientRect().left;
      var b = track.children[setCount].getBoundingClientRect().left;
      setW = b - a;
      if (setW <= 0) return;                          // hidden panel: nothing to measure yet
      // pos always lands in [0, setW), so the visible window is [pos, pos+vpW] at worst.
      // The track must cover that or a loop could expose bare background — append whole
      // sets until it does. Cards are driven by delegated listeners, so clones stay live.
      var guard = 0;
      while (track.getBoundingClientRect().width < setW + vp.clientWidth + GAP && guard++ < 8) {
        var frag = document.createDocumentFragment();
        for (var i = 0; i < setCount; i++) frag.appendChild(track.children[i].cloneNode(true));
        track.appendChild(frag);
        markClones();
      }
    }

    function render() { track.style.transform = 'translate3d(' + -pos + 'px,0,0)'; }
    function moveTo(v) {
      pos = setW > 0 ? ((v % setW) + setW) % setW : v; // the modulo is the whole trick
      render();
    }
    function stopAnim() { if (anim) cancelAnimationFrame(anim); anim = null; }

    /* Auto-rotation. Speed is px per second from the section setting (0 = off), applied
       against real elapsed time so it looks the same on a 60Hz and a 120Hz screen.
       dt is clamped because rAF stalls while a tab is backgrounded: without the clamp the
       first frame back would carry one huge delta and the rail would visibly jump. */
    var autoSpeed = parseFloat(rot.getAttribute('data-rot-auto')) || 0;
    var autoRaf = null, autoLast = 0, held = false, hovering = false, inView = true, idleT = null;

    function autoFrame(ts) {
      var dt = autoLast ? Math.min((ts - autoLast) / 1000, 0.05) : 0;
      autoLast = ts;
      moveTo(pos + autoSpeed * dt);
      autoRaf = requestAnimationFrame(autoFrame);
    }
    function autoStart() {
      if (!autoSpeed || reduce || autoRaf || held || hovering || !inView || anim || setW <= 0) return;
      autoLast = 0;
      autoRaf = requestAnimationFrame(autoFrame);
    }
    function autoStop() { if (autoRaf) cancelAnimationFrame(autoRaf); autoRaf = null; }
    // Hand control back a beat after the visitor stops interacting, not instantly.
    function autoResumeSoon() {
      clearTimeout(idleT);
      idleT = setTimeout(function () { held = false; autoStart(); }, 2200);
    }
    function autoHold() { held = true; clearTimeout(idleT); autoStop(); }

    // Arrows / keyboard: one viewport-width page, rounded down to whole cards.
    function stepPx() {
      var w = itemW();
      return Math.max(1, Math.floor(vp.clientWidth / w)) * w;
    }
    function animateBy(delta) {
      stopAnim();
      if (reduce) { moveTo(pos + delta); return; }
      var from = pos, t0 = null, dur = 480;
      function frame(ts) {
        if (t0 == null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        moveTo(from + delta * (1 - Math.pow(1 - p, 3)));
        if (p < 1) { anim = requestAnimationFrame(frame); }
        else { anim = null; autoStart(); }
      }
      anim = requestAnimationFrame(frame);
    }

    // Fling: plain friction decay. It can run as long as it likes — moveTo normalises
    // every frame, so a hard swipe cannot walk the rail out of range.
    function glide(v) {
      stopAnim();
      if (reduce || Math.abs(v) < 0.5) return;
      function frame() {
        v *= 0.94;
        moveTo(pos + v);
        if (Math.abs(v) > 0.15) { anim = requestAnimationFrame(frame); }
        else { anim = null; autoStart(); }
      }
      anim = requestAnimationFrame(frame);
    }

    var dragging = false, axis = null, startX = 0, startY = 0, startPos = 0, lastX = 0, lastT = 0, vel = 0, moved = 0;
    vp.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      stopAnim(); autoHold();                           // a touch takes over immediately
      dragging = true; axis = null; moved = 0; vel = 0;
      startX = lastX = e.clientX; startY = e.clientY; startPos = pos; lastT = e.timeStamp;
    });
    vp.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (axis == null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        // Vertical intent belongs to the page, not the rail — bow out entirely.
        if (Math.abs(dy) >= Math.abs(dx)) { dragging = false; return; }
        axis = 'x';
        vp.setPointerCapture(e.pointerId);
        vp.classList.add('is-drag');
      }
      var dt = e.timeStamp - lastT;
      if (dt > 0) vel = (e.clientX - lastX) / dt * 16;  // px per frame
      lastX = e.clientX; lastT = e.timeStamp; moved = Math.abs(dx);
      moveTo(startPos - dx);
      e.preventDefault();
    });
    function endDrag() {
      autoResumeSoon();
      if (!dragging) { axis = null; return; }
      dragging = false;
      vp.classList.remove('is-drag');
      if (axis === 'x') glide(-vel);
      axis = null;
    }
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    // A drag that ends on a card must not also open that card.
    vp.addEventListener('click', function (e) {
      if (moved > 8) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    vp.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;  // vertical wheel scrolls the page
      stopAnim(); autoHold(); autoResumeSoon();
      moveTo(pos + e.deltaX);
      e.preventDefault();
    }, { passive: false });

    vp.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      autoHold(); autoResumeSoon();
      animateBy(e.key === 'ArrowRight' ? stepPx() : -stepPx());
      e.preventDefault();
    });

    function nudge(delta) { autoHold(); autoResumeSoon(); animateBy(delta); }
    var prev = rot.querySelector('[data-rot-prev]');
    var next = rot.querySelector('[data-rot-next]');
    if (prev) prev.addEventListener('click', function () { nudge(-stepPx()); });
    if (next) next.addEventListener('click', function () { nudge(stepPx()); });

    // Hover-pause, so a moving card isn't a moving target when someone goes to click it.
    // Gated on real hover support: on touch, pointerenter fires without a matching leave
    // and the rail would stay stopped for good.
    if (window.matchMedia('(hover: hover)').matches) {
      vp.addEventListener('pointerenter', function () { hovering = true; autoStop(); });
      vp.addEventListener('pointerleave', function () { hovering = false; autoStart(); });
    }
    // Don't burn frames on a rail nobody can see — this also covers the quick-rail panels,
    // which are display-hidden until their tab is picked.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting;
        if (inView) autoStart(); else autoStop();
      }, { threshold: 0 }).observe(vp);
    }
    // Returning to a backgrounded tab: drop the stale timestamp so the next frame starts
    // a fresh clock instead of measuring the whole time away.
    document.addEventListener('visibilitychange', function () { autoLast = 0; });

    function remeasure() { measure(); moveTo(pos); autoStart(); }
    vp.classList.add('rot-js');
    markClones();
    remeasure();
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);       // lazy card images settle widths late
    // A rail in a hidden quick-rail panel measures 0 wide; its tab handler fires this once
    // the panel is shown so the loop gets its real set width.
    document.addEventListener('rot:sync', remeasure);
  });

  /* ---------- brand marquee: page scroll speed drives marquee speed ----------
     Swaps the CSS keyframe animation for a JS-driven transform so the speed
     can ramp smoothly with scroll velocity instead of jumping (changing a CSS
     animation-duration mid-loop causes a visible position jump). Falls back
     to the plain CSS loop if JS never runs or reduced-motion is set. */
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.bmq').forEach(function (root) {
      var track = root.querySelector('.bmq-track');
      if (!track) return;
      var dur = parseFloat(track.style.getPropertyValue('--bmq-dur')) || 30;
      track.style.animation = 'none';
      var half = 0, pos = 0, hovered = false, lastScrollY = window.scrollY, velocity = 0, lastTs = null;
      function measure() { half = track.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure);
      root.addEventListener('mouseenter', function () { hovered = true; });
      root.addEventListener('mouseleave', function () { hovered = false; });
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        velocity = Math.max(velocity, Math.abs(y - lastScrollY));
        lastScrollY = y;
      }, { passive: true });
      function tick(ts) {
        if (half <= 0) measure();
        if (lastTs == null) lastTs = ts;
        var dt = Math.min((ts - lastTs) / 1000, 0.05); lastTs = ts;
        if (!hovered && half > 0) {
          var baseSpeed = half / dur;
          var boost = Math.min(velocity * 6, baseSpeed * 5);
          pos = (pos + (baseSpeed + boost) * dt) % half;
          track.style.transform = 'translateX(' + (-pos) + 'px)';
        }
        velocity *= 0.88;
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  })();

  /* ---------- expose so inline section scripts can reuse ---------- */
  window.zenseWireAccordion = wireAccordion;

  refreshCount();

  /* ---------- light / dark theme toggle ---------- */
  (function () {
    var btn = document.getElementById('themeToggle');
    if (!btn) return;
    var root = document.documentElement;
    var meta = document.querySelector('meta[name="theme-color"]');
    function apply(theme) {
      if (theme === 'light') root.setAttribute('data-theme', 'light');
      else root.removeAttribute('data-theme');
      if (meta) meta.setAttribute('content', theme === 'light' ? '#f5f5f4' : '#0a0a0c');
      btn.setAttribute('aria-pressed', theme === 'light' ? 'true' : 'false');
    }
    apply(root.getAttribute('data-theme') === 'light' ? 'light' : 'dark');
    btn.addEventListener('click', function () {
      var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
      try { localStorage.setItem('zense-theme', next); } catch (e) {}
      apply(next);
    });
  })();

  /* ---------- collection filters: preserve sort/availability query string across the
     tag-path (Gender/Occasion/Type) chip links, which are built server-side without it ---------- */
  (function () {
    var qs = window.location.search;
    if (!qs) return;
    document.querySelectorAll('#filterForm .fgroup .chip[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href.indexOf('?') === -1) a.setAttribute('href', href + qs);
    });
  })();

  /* ---------- statement word reveal (scroll-scrubbed) ----------
     Words brighten one by one, tied to how far the section has scrolled
     into view — scrubbing back up dims them again. */
  (function () {
    var sections = document.querySelectorAll('.statement');
    if (!sections.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var words = sec.querySelectorAll('.st-w');
      if (!words.length) return;
      if (reduced) {
        words.forEach(function (w) { w.classList.add('lit'); });
        return;
      }
      var ticking = false;
      function update() {
        ticking = false;
        var r = sec.getBoundingClientRect();
        var vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = (vh * 0.9 - r.top) / (vh * 0.65);
        p = Math.max(0, Math.min(1, p));
        var lit = Math.round(p * words.length);
        for (var i = 0; i < words.length; i++) words[i].classList.toggle('lit', i < lit);
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
    });
  })();

  /* ---------- "Find Your Scent" quiz (UIUX plan item 12) ----------
     3 real questions mapped to the site's actual Gender/Occasion/Type tags.
     Ends on the live tag-path collection URL — same filter system the
     homepage category tiles already use, so results are always real. */
  (function () {
    var overlay = document.getElementById('quizOverlay');
    if (!overlay) return;
    var box = overlay.querySelector('.quiz-box');
    var steps = Array.prototype.slice.call(overlay.querySelectorAll('.quiz-step'));
    var dots = Array.prototype.slice.call(overlay.querySelectorAll('.qp-dot'));
    var backBtn = document.getElementById('quizBack');
    var resultLink = document.getElementById('quizResultLink');
    var resultSub = document.getElementById('quizResultSub');
    var answers = [];
    var current = 0;

    function render() {
      steps.forEach(function (s) { s.hidden = parseInt(s.dataset.step, 10) !== current; });
      dots.forEach(function (d, i) {
        var n = parseInt(d.dataset.step, 10);
        d.classList.toggle('active', n === current);
        d.classList.toggle('done', n < current);
      });
      backBtn.hidden = current === 0 || current > 1;
      if (current === 2) resolveMatches();
    }

    /* The catalog is small enough that a random gender+occasion combo can have
       zero exact matches. Rather than dead-end, check the real product count
       for the full combo, then fall back to gender alone — always a live
       count, never a guessed/fabricated one. */
    function tagUrl(tags) { return '/collections/all/' + tags.join('+'); }
    function fetchCount(url) {
      return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var m = html.match(/class="count">\s*(\d+)/);
        return m ? parseInt(m[1], 10) : 0;
      }).catch(function () { return 0; });
    }
    function applyResult(tags, note) {
      resultLink.setAttribute('href', tagUrl(tags));
      resultLink.classList.remove('loading');
      resultSub.textContent = note;
    }
    function resolveMatches() {
      var full = answers.slice();
      var reqId = ++resolveMatches._id;
      resultLink.classList.add('loading');
      resultSub.textContent = 'Finding your matches…';
      fetchCount(tagUrl(full)).then(function (count) {
        if (reqId !== resolveMatches._id) return;
        if (count > 0) { applyResult(full, full.join(' · ') + ' — filtered to exactly that combination.'); return; }
        applyResult([full[0]], full[0] + ' — showing every scent in that category.');
      });
    }
    resolveMatches._id = 0;
    function goTo(n) {
      current = n;
      render();
    }
    overlay.addEventListener('click', function (e) {
      var opt = e.target.closest('.quiz-opt');
      if (opt) {
        answers[current] = opt.dataset.tag;
        goTo(current + 1);
        return;
      }
      if (e.target === overlay) closeQuiz();
    });
    backBtn.addEventListener('click', function () { if (current > 0) goTo(current - 1); });
    var restart = document.getElementById('quizRestart');
    if (restart) restart.addEventListener('click', function () { answers = []; goTo(0); });
    document.getElementById('quizClose').addEventListener('click', closeQuiz);
    function openQuiz() {
      answers = [];
      goTo(0);
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    function closeQuiz() {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) closeQuiz();
    });
    ['quizOpenNav', 'quizOpenDrawer'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', openQuiz);
    });
  })();

  /* ---------- HIM/HER/UNISEX quick-rail tabs (UIUX plan item 14) ---------- */
  (function () {
    document.querySelectorAll('.qrail').forEach(function (rail) {
      var tabs = Array.prototype.slice.call(rail.querySelectorAll('.qtab'));
      var panels = Array.prototype.slice.call(rail.querySelectorAll('.qpanel'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.qtab;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.dataset.qpanel === key;
            p.classList.toggle('active', on);
            p.hidden = !on;
          });
          // The rail that just became visible has real width for the first time, so let
          // it re-read its scroll bounds. (Rail scrolling itself lives in the [data-rot]
          // initializer above — this section no longer wires up its own arrows.)
          document.dispatchEvent(new Event('rot:sync'));
        });
      });
    });
  })();

  /* ---------- hero parallax (UIUX plan item 5) ----------
     Background image drifts at ~0.5x scroll speed via background-position;
     floating chips drift slightly less. rAF-throttled, transform-only for the
     chips (background-position on a single element is cheap enough here). */
  (function () {
    var hero = document.querySelector('.hero');
    var right = document.querySelector('.hero-right');
    if (!hero || !right) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 900px)').matches) return; // stacked layout: skip
    var chips = document.querySelectorAll('.float-chip');
    var ticking = false;
    function update() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var offset = r.top * -0.5;
      right.style.backgroundPosition = 'center calc(50% + ' + offset + 'px)';
      chips.forEach(function (c, i) {
        var mult = i === 0 ? 0.12 : -0.16;
        c.style.transform = 'translateY(' + (r.top * mult) + 'px)';
      });
    }
    function onScroll() {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();

  /* ---------- animated stat counters (UIUX plan item 9) ----------
     Counts up any plain integer found in a stat value (33, 199, 4...).
     Ranges like "12–14" and non-numeric values ("Made in India") are left
     static — counting only one side of a range or a word reads oddly. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = [];
    document.querySelectorAll('.hero-trust .t .n span, .bignum .b .n').forEach(function (el) {
      var html = el.innerHTML;
      if (/\d+[–—-]\d+/.test(html)) return; // range — skip
      var m = html.match(/\d+/);
      if (!m) return;
      targets.push({ el: el, html: html, target: parseInt(m[0], 10), match: m[0] });
    });
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var t = targets.filter(function (x) { return x.el === en.target; })[0];
        if (!t) return;
        var start = null, dur = 1200;
        function frame(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(eased * t.target);
          t.el.innerHTML = t.html.replace(t.match, val);
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });
    targets.forEach(function (t) { io.observe(t.el); });
  })();

  /* ---------- scroll reveal ----------
     Elements get .rv (hidden) + a per-sibling stagger delay, then .rv-in when they
     enter the viewport. Runs synchronously before first paint (script sits at the
     end of <body>), so anything already in view is stamped with both classes at
     once and renders instantly — only below-the-fold content animates. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var SELECTORS = [
      '.sec-head',
      '.bs .feat', '.bs .mini',
      '.rot',
      '.collections .col-tile',
      '.nrow',
      '.story-in > *', '.bignum .b',
      '.discover-in > *',
      '.grid .pcardx',
      '.cross-grid .pcardx',
      '.pgrid .pcard',
      '.ctiles .ctile',
      '.assure .a',
      '.freeship-bar',
      '.contact-grid > *',
      '.trust-track .tcard'
    ];
    var els = [];
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (els.indexOf(el) === -1) els.push(el);
      });
    });
    if (!els.length) return;
    var counts = [];
    els.forEach(function (el) {
      var p = el.parentElement, entry = null;
      for (var i = 0; i < counts.length; i++) if (counts[i].p === p) { entry = counts[i]; break; }
      if (!entry) { entry = { p: p, n: 0 }; counts.push(entry); }
      el.style.setProperty('--rvd', Math.min(entry.n * 70, 420) + 'ms');
      entry.n++;
      el.classList.add('rv');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('rv-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) el.classList.add('rv-in');
      else io.observe(el);
    });
  })();

  /* ---------- search: surface related fragrances, not just exact-word matches ----------
     Native search already matches title/tags. This scores the full catalog against the
     query across notes (top/heart/base) and "inspired by" too, so e.g. searching a note
     ("rose") or a reference fragrance name ("sauvage") surfaces relevant products even
     when those words never appear in the product title. Related matches are appended
     straight into the same results grid — no "no exact match" messaging, just products. */
  (function () {
    var catalog = document.getElementById('search-catalog');
    var grid = document.getElementById('search-grid');
    if (!catalog || !grid) return;
    var terms = (catalog.dataset.terms || '').toLowerCase();
    var tokens = terms.split(/\s+/).filter(function (t) { return t.length >= 3; });

    if (tokens.length) {
      var shown = {};
      grid.querySelectorAll('.pcardx[data-handle]').forEach(function (el) {
        shown[el.dataset.handle] = true;
      });
      var scored = [];
      catalog.querySelectorAll('.catalog-item').forEach(function (item) {
        var card = item.querySelector('.pcardx[data-handle]');
        if (!card || shown[card.dataset.handle]) return;
        var hay = item.dataset.hay || '';
        var score = 0;
        tokens.forEach(function (t) { if (hay.indexOf(t) !== -1) score++; });
        if (score > 0) scored.push({ card: card, score: score });
      });
      scored.sort(function (a, b) { return b.score - a.score; });
      scored.forEach(function (s) { grid.appendChild(s.card); });
    }

    var empty = document.getElementById('search-empty');
    if (empty) empty.hidden = grid.children.length > 0;
  })();

  /* ---------- header search bar: same related-by-notes scoring, inline in the dropdown ----------
     Site-wide lightweight catalog (title/tags/notes/inspired-by) embedded in the layout so the
     predictive dropdown can blend in relevant fragrances alongside Shopify's native suggestions. */
  var zenseSearchCatalog = (function () {
    var el = document.getElementById('search-catalog-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();
  function zenseScoreCatalog(query, excludeUrls) {
    if (!zenseSearchCatalog) return [];
    var tokens = query.toLowerCase().split(/\s+/).filter(function (t) { return t.length >= 3; });
    if (!tokens.length) return [];
    var scored = [];
    zenseSearchCatalog.forEach(function (p) {
      if (excludeUrls[p.url]) return;
      var score = 0;
      tokens.forEach(function (t) { if (p.hay.indexOf(t) !== -1) score++; });
      if (score > 0) scored.push({ p: p, score: score });
    });
    scored.sort(function (a, b) { return b.score - a.score; });
    return scored.map(function (s) { return s.p; });
  }
  window.zenseScoreCatalog = zenseScoreCatalog;
})();
